var enableOn = window.innerWidth > 300;
var start = 100;

var scrollStarted = function() {
	var top = window.pageYOffset;

	if (document.documentElement.scrollHeight - window.innerHeight <= top) {
		document.body.classList.add("is-scrolled-bottom");
	} else if (top >= start) {
		document.body.classList.add("is-scrolled");
		document.body.classList.remove("is-scrolled-bottom");
	} else {
		document.body.classList.remove("is-scrolled", "is-scrolled-bottom");
	}
};

if (enableOn) {
	window.addEventListener("scroll", function() {
		window.requestAnimationFrame(scrollStarted);
	});
	scrollStarted();
}
